<template>
  <div class="container mt-5">
    <Loading v-if="!teams"/>
    <div v-if="teams">
      <div class="row mb-4">
        <div class="col-8">
          <h3>Teams</h3>
        </div>
        <div class="col-4 text-right">
          <router-link :to="{ name: 'TeamAdd' }"><button type="button" class="btn btn-primary">New Team</button></router-link>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12">
          <input type="text" name="search" id="search" class="form-control form-control-lg" placeholder="Search for a team (name)..." v-model="searchText">
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-3" v-for="team of teamsFiltered" :key="team._id">
              <router-link :to="{ name: 'TeamShow', params: { id: team._id }}">
              <div class="card team">
                <div><b>{{team.name}}</b></div>
                <div>
                  <span v-if="competitions" class="badge badge-secondary" v-for="tc of team.teamCompetitions" :key="tc._id">{{tc.competitionName}}</span>
                </div>
              </div>
              </router-link>
            </div>
          </div>
          <!-- <table class="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="team of teams" :key="team._id">
                <td><router-link :to="{ name: 'TeamShow', params: { id: team._id }}">{{team.name}}</router-link></td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { teamService } from '@/services/team'
import { competitionService } from '@/services/competition'
import _ from 'lodash'
export default {
  name: 'Teams',
  data () {
    return {
      teams: null,
      competitions: null,
      searchText: ''
    }
  },
  computed: {
    teamsFiltered () {
      if (this.searchText === '') return this.teams
      else {
        let text = _.toLower(this.searchText)
        let exclude = null
        return _.filter(this.teams, function (object) {
          return _(object).omit(exclude).some(function (string) {
            return _(string).toLower().includes(text)
          })
        })
      }
    }
  },
  mounted () {
    teamService.getAll().then(result => {
      this.teams = result.data.teams
      competitionService.getAll().then(result => {
        this.competitions = result.data.competitions

        for (let team of this.teams) {
          for (let tc of team.teamCompetitions) {
            const filter = this.competitions.filter(competition => competition._id === tc.competition)
            tc.competitionName = filter[0] ? filter[0].name : ''
          }
        }
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.team{
  padding: 10px;
  margin-bottom: 15px;
  min-height: 95px;

  span.badge{
    display: inline !important;
  }
}

a:hover{
    text-decoration: none;
    color:grey;
}
a{
  color: rgb(46, 46, 46);
}
</style>



// WEBPACK FOOTER //
// src/pages/Teams/Teams.vue